import { render } from "./tuesday.vue?vue&type=template&id=664aa00c&scoped=true"
import script from "./tuesday.vue?vue&type=script&lang=js"
export * from "./tuesday.vue?vue&type=script&lang=js"

import "./tuesday.vue?vue&type=style&index=0&id=664aa00c&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664aa00c"]])

export default __exports__